import React, { useEffect, useState, useRef } from "react";
import { Container, Typography, Paper, Button, Alert } from "@mui/material";
import SubscriptionModal from "./SubscriptionModal";
import api from "../../api/api";
import AuthService from "../../../services/AuthService";

function Profile() {
  const [profileData, setProfileData] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [userRole, setUserRole] = useState(null);

  const [loadError, setLoadError] = useState("");
  const requestVersion = useRef(0);
  const fetchProfileData = async () => {
    const version = ++requestVersion.current;
    setLoadError("");
    try {
      const token = localStorage.getItem("token");
      
      
      if (!token) {
        throw new Error("Войдите в аккаунт для просмотра профиля");
      }

      // Безопасно получаем роль пользователя
      let role;
      try {
        role = await AuthService.getSafeUserRole();
        if (version !== requestVersion.current) return;
        setUserRole(role);
      } catch {
        throw new Error("Не удалось определить роль пользователя");
      }

      let endpoint;
      // Определяем эндпоинт в зависимости от роли
      if (role === "founder") {
        endpoint = "/founder/profile";
      } else if (role === "manager") {
        endpoint = "/staff/profile";
      } else {
        throw new Error(`Неподдерживаемая роль пользователя: ${role}`);
      }

      const response = await api.get(endpoint, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });


      if (version !== requestVersion.current) return;
      // Устанавливаем данные профиля
      setProfileData({
        ...response.data,
        business_name: response.data.business_name || "Не указан", // Используем поле business_name
      });
    } catch (error) {
      if (version === requestVersion.current) setLoadError("Не удалось загрузить профиль. Попробуйте ещё раз.");
    }
  };

  useEffect(() => {
    fetchProfileData();
    return () => { requestVersion.current += 1; };
  }, []);

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  if (loadError) {
    return <Alert severity="error" action={<Button onClick={fetchProfileData}>Повторить</Button>}>{loadError}</Alert>;
  }

  if (!profileData) {
    return <Typography>Загрузка данных...</Typography>;
  }

  return (
    <Container maxWidth="md" style={{ marginTop: "20px" }}>
      <Paper style={{ padding: "20px", marginBottom: "20px" }}>
        <Typography variant="h4">
          {profileData.full_name || `${profileData.first_name || ''} ${profileData.last_name || ''}`.trim() || 'Профиль пользователя'}
        </Typography>
        
        <Typography variant="subtitle1" style={{ marginTop: "10px" }}>
          <strong>Email:</strong> {profileData.email}
        </Typography>
        
        <Typography variant="subtitle1">
          <strong>Роль:</strong> {userRole === "founder" ? "Основатель" : userRole === "manager" ? "Менеджер" : userRole}
        </Typography>

        {/* Данные для основателя */}
        {userRole === "founder" && (
          <>
            <Typography variant="subtitle1">
              <strong>Компания:</strong> {profileData.company_name || "Не указана"}
            </Typography>
            <Typography variant="subtitle1">
              <strong>Выбранный бизнес:</strong>{" "}
              {profileData.business_name || "Не указан"}
            </Typography>
            <Typography variant="subtitle1">
              <strong>Оставшиеся дни подписки:</strong> {profileData.days_left}
            </Typography>
            <Typography variant="subtitle1">
              <strong>Дата окончания подписки:</strong>{" "}
              {profileData.subscription_end_date ? new Date(profileData.subscription_end_date).toLocaleDateString() : "Не указана"}
            </Typography>
            <Button
              variant="contained"
              color="primary"
              style={{ marginTop: "20px" }}
              onClick={handleOpenModal}
            >
              Продлить подписку
            </Button>
          </>
        )}

        {/* Данные для сотрудника */}
        {userRole === "manager" && (
          <>
            <Typography variant="subtitle1">
              <strong>Номер сотрудника:</strong> {profileData.staff_number || "Не присвоен"}
            </Typography>
            <Typography variant="subtitle1">
              <strong>Телефон:</strong> {profileData.phone || "Не указан"}
            </Typography>
            <Typography variant="subtitle1">
              <strong>Дата рождения:</strong> {profileData.date_of_birth ? new Date(profileData.date_of_birth).toLocaleDateString() : "Не указана"}
            </Typography>
            <Typography variant="subtitle1">
              <strong>Адрес:</strong> {profileData.address || "Не указан"}
            </Typography>
            {profileData.rental_point_name && (
              <Typography variant="subtitle1">
                <strong>Пункт аренды:</strong> {profileData.rental_point_name}
              </Typography>
            )}
            <Typography variant="subtitle1">
              <strong>Дата создания:</strong> {profileData.created_at ? new Date(profileData.created_at).toLocaleDateString() : "Не указана"}
            </Typography>
          </>
        )}
      </Paper>

      {/* Модал подписки только для основателей */}
      {userRole === "founder" && (
        <SubscriptionModal
          open={isModalOpen}
          onClose={handleCloseModal}
          onSubscriptionExtended={fetchProfileData}
        />
      )}
    </Container>
  );
}

export default Profile;
